import useViewportTier from './useViewportTier';

/** True between the `s` and `m` breakpoints (784–1023px). Aligned to the theme breakpoints. */
export default function useIsTablet() {
  return useViewportTier() === 'tablet';
}
